import { render, staticRenderFns } from "./SidebarBlock.vue?vue&type=template&id=1ade0dea&scoped=true"
import script from "./SidebarBlock.vue?vue&type=script&lang=js"
export * from "./SidebarBlock.vue?vue&type=script&lang=js"
import style0 from "./SidebarBlock.vue?vue&type=style&index=0&id=1ade0dea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ade0dea",
  null
  
)

export default component.exports